<script setup>
import { computed, ref } from 'vue';
import { navItems } from '@/helpers/navigationPanelHelper.js';
import { useNavigationPanelStore } from '@/stores/navigationPanel';
import CreateOrderByImportStep1 from './createByImport/CreateOrderByImportStep1.vue';
import CreateOrderByImportStep2 from './createByImport/CreateOrderByImportStep2.vue';
import CreateOrderByImportStep3 from './createByImport/CreateOrderByImportStep3.vue';
import WizardComponent from '../utils/WizardComponent.vue';

const navigationPanelStore = useNavigationPanelStore();
const createOrderByImportStep1Ref = ref();
const createOrderByImportStep2Ref = ref();
const createOrderByImportStep3Ref = ref();
const importType = ref(null);
const attachment5 = ref(null);
const attachment6 = ref(null);

const firstStepHeader = computed(() => {
  if (importType.value == null) return '1. Wybór typu importu';

  const importTypeText = importType.value === 'POLES' ? 'Słupy' : 'Szafy';
  return `1. Wybór typu importu (Wybrano: ${importTypeText})`;
});

const stepsConfig = computed(() => [
  {
    number: 1,
    header: firstStepHeader.value,
    onPreviousAction: null,
    onNextAction: () => {
      importType.value = createOrderByImportStep1Ref.value?.importType;
    },
    previousButtonDisabled: true,
    nextButtonDisabled: createOrderByImportStep1Ref.value?.importType == null
  },
  {
    number: 2,
    header: '2. Import załączników',
    onPreviousAction: () => {
      // reset attachments when going back to step 1
      attachment5.value = null;
      attachment6.value = null;
    },
    onNextAction: () => {
      attachment5.value = createOrderByImportStep2Ref.value?.attachment5 || null;
      attachment6.value = createOrderByImportStep2Ref.value?.attachment6 || null;
    },
    previousButtonDisabled: false,
    nextButtonDisabled: createOrderByImportStep2Ref.value?.bothAttachmentsUploaded !== true
  },
  {
    number: 3,
    header: '3. Podsumowanie importu',
    onPreviousAction: () => {
      // reset attachments when going back to step 2
      attachment5.value = null;
      attachment6.value = null;
    },
    onNextAction: null,
    previousButtonDisabled: false,
    nextButtonDisabled: false
  }
]);

function onFinished() {
  createOrderByImportStep3Ref.value?.requestFormSubmit();
}

// created
navigationPanelStore.setNavigationPanelItems(navItems.CREATE_ORDER_BY_IMPORT);
</script>

<template>
  <WizardComponent :steps="stepsConfig" :onFinishAction="onFinished">
    <template #wizardContent1>
      <CreateOrderByImportStep1 ref="createOrderByImportStep1Ref" />
    </template>
    <template #wizardContent2>
      <CreateOrderByImportStep2 ref="createOrderByImportStep2Ref" />
    </template>
    <template #wizardContent3>
      <CreateOrderByImportStep3
        v-if="attachment5 != null && attachment6 != null"
        ref="createOrderByImportStep3Ref"
        :importType="importType"
        :attachment5="attachment5"
        :attachment6="attachment6"
      />
      <div
        v-else
        style="height: 150px; display: flex; align-items: center; justify-content: center"
      >
        Brak załączników. Coś poszło nie tak. Proszę odświeżyć stronę i spróbować ponownie.
      </div>
    </template>
  </WizardComponent>
</template>

<style scoped></style>
